import { j as e } from "../../../../_virtual/jsx-runtime.js";
import { cn as a } from "../../../../lib/utils.js";
const u = ({ config: d, onClick: s, className: l }) => {
  const n = (t, r) => {
    switch (t) {
      case "dot-line":
        return /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "h-0.5 w-4 border-t-2 border-dotted bg-transparent",
            style: {
              borderColor: r
            }
          }
        );
      case "bar-left":
        return /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "h-2.5 w-4 rounded-l-md",
            style: { backgroundColor: r }
          }
        );
      case "bar":
        return /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "h-3 w-2.5 rounded-t-md",
            style: { backgroundColor: r }
          }
        );
      default:
        return /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "h-0.5 w-4",
            style: {
              backgroundColor: r
            }
          }
        );
    }
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: a(
        "flex flex-row flex-wrap gap-y-4 justify-center pt-4 px-2",
        s ? "cursor-pointer" : "",
        l
      ),
      children: d.map(({ dataKey: t, label: r, color: m, type: o, className: c }) => /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: a("flex items-center mx-4", c),
          onClick: s == null ? void 0 : s.bind(void 0, t),
          children: [
            n(o, m),
            /* @__PURE__ */ e.jsx("span", { className: "ml-2 text-sm", children: r })
          ]
        },
        t
      ))
    }
  );
};
export {
  u as default
};
